<script>
  import IoMdArrowDropleft from "svelte-icons/io/IoMdArrowDropleft.svelte";
  import IoMdArrowDropright from "svelte-icons/io/IoMdArrowDropright.svelte";

  export let address;
  export let origin;
  export let events;
  let pageIndex = 0;

  function changePageIndex(newPageIndex) {
    if (newPageIndex >= 0 && newPageIndex < events.length) {
      pageIndex = newPageIndex;
    }
  }
</script>

<div class="modalContainer">
  <div class="iconContainer">
    {#if pageIndex != 0}
      <div class="icon" on:click={() => changePageIndex(pageIndex - 1)}>
        <IoMdArrowDropleft />
      </div>
    {/if}
  </div>
  <div class="modalContent">
    <!-- <p><b>Date:</b> {events[pageIndex]["fileDate"]}</p> -->
    <p><b>Address:</b> {address}</p>
    <!-- <p><b>Plaintiff:</b> {events[pageIndex]["plaintiff"]}</p> -->
    <!-- <p><b>Eviction:</b> {pageIndex + 1} of {events.length}</p> -->
    <p><b>Origin:</b> {origin}</p>
  </div>
  <!-- <div class="iconContainer">
    {#if pageIndex != events.length - 1}
      <div class="icon" on:click={() => changePageIndex(pageIndex + 1)}>
        <IoMdArrowDropright />
      </div>
    {/if}
  </div> -->
</div>

<style>
  .modalContainer {
    display: flex;
    flex-direction: row;
  }
  .modalContent {
    width: 80%;
  }
  .iconContainer {
    display: flex;
    border: 0;
    padding: 0;
    width: 10%;
    align-items: center;
  }
  .icon {
    border: 0;
    padding: 0;
  }
  .icon:hover {
    cursor: pointer;
  }
</style>
